// The @astrana/ui documents lib fires getDocument / getDocumentAdditionalInfo /
// downloadDocument with only a documentId, but care-management-gql needs the
// member's companyId + MPI to resolve the doc from PP's GetMemberDocuments list
// (PP has no by-uid endpoint). MemberDocumentsPage publishes the active member
// here and the Apollo authLink forwards it as x-pp-company-id / x-pp-member-mpi.
// Only one member's documents are viewed at a time, so a module-level holder is
// sufficient.

interface PpDocScope {
  companyId?: string;
  membMpiNo?: string;
}

let scope: PpDocScope = {};

export function setPpDocScope(next: PpDocScope): void {
  scope = next ?? {};
}

export function clearPpDocScope(): void {
  scope = {};
}

export function getPpDocScope(): PpDocScope {
  return scope;
}
